import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AccountBoxTwoToneIcon from '@mui/icons-material/AccountBoxTwoTone';
import LogoutIcon from '@mui/icons-material/Logout';
import { getEmployeeById } from 'src/services/employeeService';
import { useDispatch } from 'react-redux';
import { LeaveManagementActions } from 'src/store/LeaveManagementReducer';
import { getEmployeeImagesById } from 'src/services/employeeService';

const UserBoxButton = styled(Box)(
  ({ theme }) => `
        height: 39.594px;
        cursor: pointer;
        width: 41.594px;
        border-radius: 8px;
        position: relative;
        overflow: hidden;
        background-color: #F4F5F7;
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

function HeaderUserbox() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [user, setuser] = useState<any>({});

  const getEmplyeeDetails = () => {
    let userId;
    if (localStorage.user) {
      const user = JSON.parse(localStorage.user || '{}');
      userId = user.EmployeeId;
    }
    getEmployeeById(userId)
      .then((res) => {
        setuser(res.data as any);
        dispatch(LeaveManagementActions.setUserDetails({
          employmentType: res.data?.employeeFinance?.type,
          gender: res.data?.gender
        }));
      })
      .catch(() => {
        navigate('/');
      });
  };

  useEffect(() => {
    getEmplyeeDetails();
  }, []);
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const onClickProfile = () => {
    let userId;
    if (localStorage.user) {
      const user = JSON.parse(localStorage.user || '{}');
      userId = user.EmployeeId;
    }
    if (userId) navigate(`/profile/details/${userId}`);
    handleClose();
  };

  const [employeeImages, setEmployeeImages] = useState([]);

  const getEmployeeImages = async (employeeId) => {
    const result = await getEmployeeImagesById(employeeId);
    let images;
    if (result.data) {
      images = result.data.map((data) => {
        const image = `data:${data.type};base64,${data.base64Value}`;
        return {
          image: image,
          id: data.id
        };
      });
      setEmployeeImages(images);
    }
  };

  useEffect(() => {
    const loggedUser = localStorage.getItem('user');
    const loggedUserObj = JSON.parse(loggedUser);
    getEmployeeImages(loggedUserObj?.EmployeeId);
  },[])

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <img
          alt="logo"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            objectFit: 'cover',
            width: '100%',
            height: '105%',
          }}
          src={
            employeeImages[0]?.image || process.env.PUBLIC_URL + '/img/new-user.png'
          }
        />
        {/* <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{user.name}</UserBoxLabel>
            <UserBoxDescription style={{ fontSize: '0.8em' }} variant="body2">
              {user.designation}
            </UserBoxDescription>
          </UserBoxText>
        </Hidden> */}
      </UserBoxButton>
      <Popover
        className='header-popover'
        style={{marginTop: '40px',marginLeft: '-10px'}}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <img
          alt="logo"
          style={{
            objectFit: 'cover',
            width: '60px',
            height: '60px',
            borderRadius: '20%'
          }}
          src={
            employeeImages[0]?.image || process.env.PUBLIC_URL + '/img/user.png'
          }
        />
          <UserBoxText>
            <UserBoxLabel variant="body1">{user.name}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {user.designation}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <List sx={{ py: 0, px: 0 }} component="nav">
          <ListItem button onClick={() => onClickProfile()}>
            <AccountBoxTwoToneIcon fontSize="small" />
            <ListItemText primary="My Profile" />
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() => {
              localStorage.removeItem('user');
              navigate('/');
            }}
          >
            <LogoutIcon fontSize="small" />
            <ListItemText primary="Sign out" />
          </ListItem>
        </List>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
